import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy photo-card composer path (`/card/create?card_id=…`), still linked from the
 * `birthday_reminder_suggestions` mail legacy sends until cutover (`mailer.py:1889`
 * picks it for `card_type_cd = 'P'`). Photo cards start in the same composer here —
 * the Customize step is its first section — so this is a rename, search carried over
 * (`card_id` is accepted by the composer route as the legacy alias of `card`).
 */
export const Route = createFileRoute("/card/create")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/card/send/create", search, replace: true });
  },
});
